import { render, staticRenderFns } from "./ManuscriptDetails.vue?vue&type=template&id=38a332eb&scoped=true&"
import script from "./ManuscriptDetails.vue?vue&type=script&lang=js&"
export * from "./ManuscriptDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManuscriptDetails.vue?vue&type=style&index=0&id=38a332eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a332eb",
  null
  
)

export default component.exports